import { useDispatch } from 'react-redux';

import { setContentOptimizerTabKey } from '../../../components/pages/contentOptimizer/mainPage/store/contentOptimizerMain.actions';
import {
    briefOutlineTabs,
    contentOptimizerContentTabValues,
    optimizerTabs,
} from '../../../components/pages/contentOptimizer/contentPage/contentOptimizerContentConstants';

import {
    contentOptimizerBriefSubTabKey,
    contentOptimizerKeywordsTabKey,
    contentOptimizerLSTabKey,
} from '../../../constants/contentOptimizer';

export const useSwitchOptimizerTabs = () => {
    const dispatch = useDispatch();

    const switchToOptimizerContentTab = () => {
        localStorage.setItem(
            contentOptimizerLSTabKey,
            contentOptimizerContentTabValues.optimizer.value
        );
        localStorage.setItem(contentOptimizerKeywordsTabKey, optimizerTabs.brief.key);
        dispatch(setContentOptimizerTabKey(contentOptimizerContentTabValues.optimizer.value));
    };

    const switchToOptimizerOutlineTab = () => {
        localStorage.setItem(
            contentOptimizerLSTabKey,
            contentOptimizerContentTabValues.brief.value
        );
        localStorage.setItem(contentOptimizerBriefSubTabKey, briefOutlineTabs.outline.key);
        dispatch(setContentOptimizerTabKey(contentOptimizerContentTabValues.brief.value));
    };

    const switchToOptimizerBriefTab = () => {
        localStorage.setItem(
            contentOptimizerLSTabKey,
            contentOptimizerContentTabValues.brief.value
        );
        localStorage.setItem(contentOptimizerBriefSubTabKey, briefOutlineTabs.brief.key);
        dispatch(setContentOptimizerTabKey(contentOptimizerContentTabValues.brief.value));
    };

    return {
        switchToOptimizerContentTab,
        switchToOptimizerOutlineTab,
        switchToOptimizerBriefTab,
    };
};
